import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import elementUi from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import PortalVue from 'portal-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import animated from 'animate.css'
import i18n from './i18n/index'
import qs from 'qs'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './assets/iconfont/iconfont.css'

Vue.use(elementUi);
NProgress.configure({
  easing: 'ease', // 动画方式    
  speed: 500, // 递增进度条的速度    
  showSpinner: false, // 是否显示加载ico    
  trickleSpeed: 200, // 自动递增间隔    
  minimum: 0.3 // 初始化时的最小百分比
})

Vue.use(BootstrapVue)
Vue.use(PortalVue)
Vue.use(VueAxios,axios);
Vue.use(animated)
Vue.prototype.$qs = qs
Vue.config.productionTip = false;

router.beforeEach((to, from , next) => {
  // 每次切换页面时，调用进度条
 NProgress.start();
 // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
  next();
});
//当路由进入后：关闭进度条
router.afterEach(() => {  
 // 在即将进入新的页面组件前，关闭掉进度条
 NProgress.done()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");